import ForgotPassword from "../app/auth/forgot";
import Forgotverification from "../app/auth/forgot/ForgotVerification";
import Login from "../app/auth/login";
import ResetPassword from "../app/auth/resetPassword";
import Signup from "../app/auth/signup";
import AllPlans from "../app/auth/signup/ChoosePlans";
import Signupverification from "../app/auth/signup/Signupverification";
import SignupSteps from "../app/auth/signupSteps";
import Branches from "../app/clients/branches";
import ClientCalendar from "../app/clients/calendar";
import ClientCatalogue from "../app/clients/catalogue";
import ClientDashboard from "../app/clients/dashboard";
import ClientPackage from "../app/clients/package";
import ClientReport from "../app/clients/report";
import ClientSales from "../app/clients/sales";
import ClientSettings from "../app/clients/settings";
import ClientTems from "../app/clients/team";
import ClientUsers from "../app/clients/users";
import AboutUs from "../app/landingPages/about";
import CustomerSupportPage from "../app/landingPages/customerSupportPage";
import Home from "../app/landingPages/home";
import MobilePage from "../app/landingPages/mobile";
import Pricing from "../app/landingPages/pricing";
import PrivacyPolicy from "../app/landingPages/privacyPolicy";
import { allIcons } from "../assets";
import ClientMarketPlace from "./../app/clients/marketPlace/index";

const landingPageRoutes = [
  {
    id: 1,
    name: "Home",
    component: <Home />,
    path: "/",
    icon: "home",
  },
  {
    id: 2,
    name: "Mobile App",
    component: <MobilePage />,
    path: "/mobile",
    icon: "mobile_screen_share",
  },
  // {
  //   id: 3,
  //   name: "Pricing",
  //   component: <Pricing />,
  //   path: "/pricing-model",
  //   icon: "monetization_on",
  // },
  {
    id: 4,
    name: "About",
    component: <AboutUs />,
    path: "/about-us",
    icon: "info",
  },
  {
    id: 4,
    name: "PrivacyPolicy",
    component: <PrivacyPolicy />,
    path: "/privacy-policy",
    icon: "info",
  },
  {
    id: 5,
    name: "Customer Support",
    component: <CustomerSupportPage />,
    path: "/customer-support",
    icon: "info",
  },
  {
    id: 5,
    name: "Login",
    component: <Login />,
    path: "/login",
    icon: "login",
  },
];

const AuthRoutes = [
  {
    id: 1,
    name: "Login",
    component: <Login />,
    path: "/login",
    icon: "location_on",
  },
  {
    id: 2,
    name: "Signup",
    component: <Signup />,
    path: "/sign-up",
    icon: "location_on",
  },
  {
    id: 2,
    name: "Signup Steps",
    component: <SignupSteps />,
    path: "/sign-up/steps",
    icon: "location_on",
  },
  {
    id: 3,
    name: "Signup Verify",
    component: <Signupverification />,
    path: "/sign-up/verify",
    icon: "location_on",
  },
  {
    id: 7,
    name: "Choose Plans",
    component: <AllPlans />,
    path: "/choose-plans",
    icon: "location_on",
  },
  {
    id: 4,
    name: "Forgot Password",
    component: <ForgotPassword />,
    path: "/forgot-password",
    icon: "location_on",
  },
  {
    id: 5,
    name: "Forgot Verify",
    component: <Forgotverification />,
    path: "/forgot-password/verify",
    icon: "location_on",
  },
  {
    id: 6,
    name: "Reset Password",
    component: <ResetPassword />,
    path: "/reset-password",
    icon: "location_on",
  },
];

const ClientRoutes = [
  {
    id: 1,
    name: "Dashboard",
    component: <ClientDashboard />,
    path: "/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 2,
    name: "Calendar",
    component: <ClientCalendar />,
    path: "/dashboard/calendar",
    icon: allIcons.calenderCheckIcon,
    iconActive: allIcons.calendarCheckActiveIcon,
  },
  {
    id: 3,
    name: "Sales",
    component: <ClientSales />,
    path: "/dashboard/sales",
    icon: allIcons.saleInacticeIcon,
    iconActive: allIcons.saleActiceIcon,
  },
  {
    id: 4,
    name: "Clients",
    component: <ClientUsers />,
    path: "/dashboard/clients",
    icon: allIcons.smileyInactive,
    iconActive: allIcons.smileyActive,
  },
  {
    id: 5,
    name: "Catalogue",
    component: <ClientCatalogue />,
    path: "/dashboard/catalogue",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  {
    id: 6,
    name: "Online Profile",
    component: <ClientMarketPlace />,
    path: "/dashboard/online-profile",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  {
    id: 7,
    name: "Branches",
    component: <Branches />,
    path: "/dashboard/branches",
    icon: allIcons.branchInactiveIcon,
    iconActive: allIcons.branchActiveIcon,
  },
  {
    id: 8,
    name: "Team",
    component: <ClientTems />,
    path: "/dashboard/team",
    icon: allIcons.teamInactiveIcon,
    iconActive: allIcons.teamActiveIcon,
  },
  {
    id: 9,
    name: "Reports",
    component: <ClientReport />,
    path: "/dashboard/report",
    icon: allIcons.reportIconInactive,
    iconActive: allIcons.reportIconActive,
  },
  // {
  //   id: 10,
  //   name: "Subscriptions",
  //   component: <ClientPackage />,
  //   path: "/dashboard/package",
  //   icon: allIcons.packageIconInactive,
  //   iconActive: allIcons.packageIconActive,
  // },
  {
    id: 11,
    name: "Setting",
    component: <ClientSettings />,
    path: "/dashboard/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

const SubClientRoutes = [
  {
    id: 1,
    name: "Dashboard",
    component: <ClientDashboard />,
    path: "/dashboard",
    icon: allIcons.dasboardInactice,
    iconActive: allIcons.dasboardActice,
  },
  {
    id: 2,
    name: "Calendar",
    component: <ClientCalendar />,
    path: "/dashboard/calendar",
    icon: allIcons.calenderCheckIcon,
    iconActive: allIcons.calendarCheckActiveIcon,
  },
  {
    id: 3,
    name: "Sales",
    component: <ClientSales />,
    path: "/dashboard/sales",
    icon: allIcons.saleInacticeIcon,
    iconActive: allIcons.saleActiceIcon,
  },
  {
    id: 4,
    name: "Clients",
    component: <ClientUsers />,
    path: "/dashboard/clients",
    icon: allIcons.smileyInactive,
    iconActive: allIcons.smileyActive,
  },
  {
    id: 5,
    name: "Catalogue",
    component: <ClientCatalogue />,
    path: "/dashboard/catalogue",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  {
    id: 6,
    name: "Online Profile",
    component: <ClientMarketPlace />,
    path: "/dashboard/online-profile",
    icon: allIcons.bookopenInactive,
    iconActive: allIcons.bookopenActive,
  },
  // {
  //   id: 7,
  //   name: "Branches",
  //   component: <Branches />,
  //   path: "/dashboard/branches",
  //   icon: allIcons.branchInactiveIcon,
  //   iconActive: allIcons.branchActiveIcon,
  // },
  {
    id: 8,
    name: "Team",
    component: <ClientTems />,
    path: "/dashboard/team",
    icon: allIcons.teamInactiveIcon,
    iconActive: allIcons.teamActiveIcon,
  },
  {
    id: 9,
    name: "Reports",
    component: <ClientReport />,
    path: "/dashboard/report",
    icon: allIcons.reportIconInactive,
    iconActive: allIcons.reportIconActive,
  },
  // {
  //   id: 10,
  //   name: "Subscriptions",
  //   component: <ClientPackage />,
  //   path: "/dashboard/package",
  //   icon: allIcons.packageIconInactive,
  //   iconActive: allIcons.packageIconActive,
  // },
  {
    id: 11,
    name: "Setting",
    component: <ClientSettings />,
    path: "/dashboard/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

const UpdateRoutes = [
  {
    id: 11,
    name: "Setting",
    component: <ClientSettings />,
    path: "/dashboard/settings",
    icon: allIcons.settingInactiveIcon,
    iconActive: allIcons.settingActiveIcon,
  },
];

export {
  AuthRoutes,
  ClientRoutes,
  landingPageRoutes,
  SubClientRoutes,
  UpdateRoutes,
};
